import React from 'react'
import styles from './lottieSection.module.css'
import Lottie from 'react-lottie'
import tracking from "../10,000+ Transactions.json"
import { lottieOptions } from '../../../utils'

function FourthSection() {
  return ( 
    <div  className={styles.secondsectionRow}>
        <p style={{color: "#0061D3"}} className={styles.secondSectionHeading}>10000+ Transactions</p>
        <p className={styles.secondSectionHeading}>processed with 100% success rate</p>
        <p className={styles.secondSectionContent}>With over 10,000 transactions successfully completed, we guarantee reliable and efficient transfers every time, trusted by thousands of users.
        </p>
        <div className={styles.lottiemobile}>
        <Lottie
              options={lottieOptions(tracking)}
            />
        
            </div>
    </div>
  )
}

export default FourthSection